import { staffRequestAssigneesSchema, staffRequestCommandResultSchema, staffRequestDetailSchema, staffRequestNoteResultSchema, staffRequestQueuePageSchema, staffSelfSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
/** The path of one staff command on one request. The id is encoded, so it can never add a path segment. */
export function staffRequestPath(requestId, action) {
    const base = `/staff/concierge-requests/${encodeURIComponent(requestId)}`;
    return action === undefined ? base : `${base}/${action}`;
}
export function createStaffRequestsApi(options) {
    const send = createMemoryTransport(options);
    const command = (requestId, action, body, commandOptions) => send({
        method: "POST",
        path: staffRequestPath(requestId, action),
        body,
        schema: staffRequestCommandResultSchema,
        idempotencyKey: commandOptions?.idempotencyKey,
        signal: commandOptions?.signal,
    });
    return {
        list(query, callOptions) {
            const params = new URLSearchParams();
            if (query?.filter !== undefined)
                params.set("filter", query.filter);
            if (query?.cursor !== undefined)
                params.set("cursor", query.cursor);
            if (query?.limit !== undefined)
                params.set("limit", String(query.limit));
            return send({
                method: "GET",
                path: "/staff/concierge-requests",
                query: params,
                schema: staffRequestQueuePageSchema,
                signal: callOptions?.signal,
            });
        },
        get: (requestId, callOptions) => send({
            method: "GET",
            path: staffRequestPath(requestId),
            schema: staffRequestDetailSchema,
            signal: callOptions?.signal,
        }),
        listAssignees: (callOptions) => send({
            method: "GET",
            path: "/staff/request-assignees",
            schema: staffRequestAssigneesSchema,
            signal: callOptions?.signal,
        }),
        getSelf: (callOptions) => send({
            method: "GET",
            path: "/staff/me",
            schema: staffSelfSchema,
            signal: callOptions?.signal,
        }),
        claim: (requestId, input, o) => command(requestId, "claim", input, o),
        reassign: (requestId, input, o) => command(requestId, "reassign", input, o),
        askCustomer: (requestId, input, o) => command(requestId, "ask-customer", input, o),
        setWorkStatus: (requestId, input, o) => command(requestId, "work-status", input, o),
        markUnavailable: (requestId, input, o) => command(requestId, "unavailable", input, o),
        decline: (requestId, input, o) => command(requestId, "decline", input, o),
        confirm: (requestId, input, o) => command(requestId, "confirm", input, o),
        complete: (requestId, input, o) => command(requestId, "complete", input, o),
        cancel: (requestId, input, o) => command(requestId, "cancel", input, o),
        setPriority: (requestId, input, o) => command(requestId, "priority", input, o),
        updateStatusSummary: (requestId, input, o) => command(requestId, "status-summary", input, o),
        addNote: (requestId, input, o) => send({
            method: "POST",
            path: staffRequestPath(requestId, "notes"),
            body: input,
            schema: staffRequestNoteResultSchema,
            idempotencyKey: o?.idempotencyKey,
            signal: o?.signal,
        }),
    };
}
